import hljs from "highlight.js"

// Only names highlight.js does not provide, or product-specific labels.
const LANGUAGE_LABEL_OVERRIDES = {
  mermaid: "Mermaid",
  xml: "html/xml",
}

export function languageLabel(language) {
  if (LANGUAGE_LABEL_OVERRIDES[language]) return LANGUAGE_LABEL_OVERRIDES[language]

  return hljs.getLanguage(language)?.name || language
}
